import { render, staticRenderFns } from "./Ubuntu18.vue?vue&type=template&id=c3c09b24&scoped=true&"
import script from "./Ubuntu18.vue?vue&type=script&lang=js&"
export * from "./Ubuntu18.vue?vue&type=script&lang=js&"
import style0 from "./Ubuntu18.vue?vue&type=style&index=0&id=c3c09b24&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3c09b24",
  null
  
)

export default component.exports